@if (HasRequiredPermissions) {
  <div class="bg-white p-6 my-8 rounded-lg shadow w-full max-w-none">
    <div class="mb-6">
      <h1 class="text-lg font-medium text-gray-700 mb-4" data-testid="list-title">
        {{ 'entities.delivery.pluralName' | translate }} ({{ totalSeen }}/{{ listView()?.entities()?.total }})
      </h1>
    </div>
    <app-list-view [entityType]="ComponentEntityClass"
      [contextMenuItems]="contextMenuItems"
      [showActions]="true"
      [canEdit]="canEdit.bind(this)"
      (entitySelected)="selectSingleItem($event)"
      (editAction)="editSelectedItem($event)"
      (deleteAction)="deleteSelectedItem($event)"
      [dismissEntity]="dismissEntityState.bind(this)"
      [onDismissAdded]="dismissEntityState.bind(this)"
      [onRowDismiss]="handleRowDismiss.bind(this)"
      [ShowRangeDateFilter]="true"
                   [fuseauxParSite]="fuseauxParSite"
                   [pagination]="{
                      enabled: true,
                      pageLengths: [5, 10, 20, 50, 100, 300],
                      defaultPageLength: 5,
                      searchColumns: ['deliveryId', 'deliveryDate', 'pickupDate', 'status', 'numberOfNotificationSent', 'employee.fullName', 'pickupByEmployee.fullName'],
                      sortableColumns: null
                    }"
      [paginatorType]="'button'"
      [showHeader]="false"
      (createButtonClick)="openCreateModal()">
      <!-- Filtre multi-critères (Status) -->
      <div slot="custom-filters" class="px-6 py-2">
        <app-multi-criteria-filter [options]="filterOptions()"
          [multiSelect]="true"
          (selectionChange)="onFilterSelectionChange($event)"
          clearButtonLabel="clearFilters">
        </app-multi-criteria-filter>
      </div>
      <!-- Colonne Photo du colis -->
      <app-list-table-column key="imagePackage.thumbnail_Path"
        title="{{ 'photo' | translate }}"
        type="custom">
        <ng-template #customTemplate let-entity>
          <div class="w-12 h-12 bg-gray-100 rounded-[4px] flex items-center justify-center overflow-hidden border border-[3px] border-gray-200 shadow-lg">
            @if (entity.imagePackage?.thumbnail_Path) {
            <img [src]="rootUrl + entity.imagePackage.thumbnail_Path" alt="Package Photo" class="w-full h-full object-contain">
            } @else {
            <i class="fas fa-box text-xl text-gray-400"></i>
            }
          </div>
        </ng-template>
      </app-list-table-column>
      <!-- Colonne DeliveryId -->
      <app-list-table-column key="deliveryId"
        title="{{ 'entities.delivery.propreties.deliveryId' | translate }}"
        type="text"
        [sortable]="true"
        align="left">
      </app-list-table-column>
      <!-- Colonne Delivery Date -->
      <app-list-table-column key="deliveryDate"
        title="{{ 'entities.delivery.propreties.deliveryDate' | translate }}"
        type="datetime"
        [sortable]="true"
        align="left">
      </app-list-table-column>
      <!-- Colonne Pick-Up Date -->
      <app-list-table-column key="pickupDate"
        title="{{ 'entities.delivery.propreties.pickupDate' | translate }}"
        type="datetime"
        [sortable]="true"
        align="left">
      </app-list-table-column>
      <!-- Colonne Recipient (employee.fullName) -->
      <app-list-table-column key="employee.fullName"
        title="{{ 'entities.delivery.propreties.recipient' | translate }}"
        type="text"
        [sortable]="true"
        align="left">
      </app-list-table-column>
      <!-- Colonne Status -->
      <app-list-table-column key="status"
        title="{{ 'entities.delivery.propreties.status' | translate }}"
        type="custom">
        <ng-template #customTemplate let-entity>
          <app-reactive-badge [status]="$safeNavigationMigration(entity?.status)"
            [lookupData]="translatedStatusLookup()"
            [Skin]="Skin"
            [isEditMode]="true"
            (statusChange)="onStatusChange($event, entity)">
          </app-reactive-badge>
        </ng-template>
      </app-list-table-column>
      <!-- Colonne Notifications -->
      <app-list-table-column key="numberOfNotificationSent"
        title="{{ 'entities.delivery.propreties.numberOfNotificationSent' | translate }}"
        type="text"
        [sortable]="true"
        align="center">
      </app-list-table-column>
    </app-list-view>
    <!-- Vue de détail -->
    <div class="fixed top-0 right-0 h-full z-50 min-w-[350px]"
      [style.width.px]="currentWidth()"
      [hidden]="!isModalOpen()">
      <div class="absolute left-0 top-0 h-full w-2 hover:w-3 hover:bg-gray-600 hover:shadow-md cursor-[ew-resize] transition-all z-[999]"
        (mousedown)="startResize($event)">
      </div>
      <div class="bg-white rounded-lg shadow-xl p-1 h-full">
        <app-delivery-detail #deliveryDetail
          [isModal]="true"
          [dataService]="dataService"
          (closeModal)="closeModal($event)"
          (itemSaved)="onItemUpdated($event)"
          (databaseUpdated)="closeModal(true)"
          [EntityInstance]="selectedItem()">
        </app-delivery-detail>
      </div>
    </div>
  </div>
}
